export const PaymentFailure = () => {
  return <div></div>;
};
